export default __webpack_public_path__ + "static/media/Steering_Behaviour.d4daa876.webp";